var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ZoomOneEduPlanDetail',_vm._b({class:{ 'opc-modal-dialog': _vm.isModal },attrs:{"show-close":!_vm.isModal},on:{"closed":_vm.handleCancel}},'ZoomOneEduPlanDetail',{
    visible: _vm.visible,
    id: _vm.id,
    currencySymbol: _vm.currencySymbol,
    enableDisplayZoomWorkFlow: _vm.enableDisplayZoomWorkFlow,
    enableDisplayZoomDrive: _vm.enableDisplayZoomDrive,
    bizCategoryCode: _vm.bizCategoryCode,
    largeMeetingCallback: _vm.largeMeetingCallback,
    fullListCallBack: _vm.fullListCallBack,
    enableDocsFeature: _vm.enableDocsFeature,
    enableDisplayZoomTasksWithoutAccountCheck: _vm.enableDisplayZoomTasksWithoutAccountCheck,
    showCampusScheduler: _vm.showCampusScheduler,
    isEligibleAccount4CustomAvatarFeature: _vm.isEligibleAccount4CustomAvatarFeature,
  },false),[(_vm.isModal)?_c('template',{slot:"back"},[_c('NavBack',{staticClass:"mb24",attrs:{"backHandler":_vm.handleCancel}})],1):_vm._e(),_c('p',{staticClass:"zone-detail-dialog__tips",attrs:{"slot":"footer"},slot:"footer"},[_vm._v(" *"+_vm._s(_vm.$t('billing.zone.edu_details.tips', [20, _vm.$money(_vm.annualPriceNum * 20, { forceDiff: true })]))+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }